import {observer} from "mobx-react-lite";
import * as React from "react";
import {RelatedRecord} from "../../models/ioc";
import {Table} from "react-bootstrap";
import DateRow from "../DateRow";

const RelatedRecordsTable = observer(function RelatedRecordsTable(props: { data: RelatedRecord[] }) {
    if (!props.data.length) {
        return <div>No data</div>
    }

    return <Table striped>
        <thead>
        <tr>
            <th>IOC</th>
            <th>Relationship</th>
            <th>Address</th>
            <th>Last Time Present</th>
            <th>Present in Targets</th>
        </tr>
        </thead>
        <tbody>
        {props.data.map((v, i) => <tr key={i}>
            <td>{v.record}</td>
            <td>{v.relationship}</td>
            <td>{v.address}</td>
            <td><DateRow timestamp={v.lastSeen}/></td>
            <td>{v.targets}</td>
        </tr>)}
        </tbody>
    </Table>
})

export default RelatedRecordsTable